<div class="page-header">
  <app-prev-next-button (click)="toIn()" direction="left" label="documentos de entrada"></app-prev-next-button>
  <h1>Conferência física</h1>
  <app-prev-next-button (click)="toStocking()" direction="right" label="estoque"></app-prev-next-button>
</div>

<div class="ctrl-bar">
  <div class="buttons">
    <div class="inventory-btn">
      <button mat-raised-button (click)="openSidenav('STOCK_INVENTORY')">
        Inventariar
      </button>
    </div>
    <div class="update-button">
      <p>Atualizado às {{actualHour}}</p>
      <button mat-raised-button (click)="update()">
        <i class="uil uil-sync"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </div>
</div>

<app-side-color-card color="in">
  <div content class="card-content">
    <div class="table-top">
      <h2>PALLETS ({{ inspectionService.totalItems$ | async | number:'1.0-0':'pt-BR' }}) - PRODUTOS ({{totalProductsCount| number:'1.0-0':'pt-BR'}})</h2>
      <div class="paginator-container">
        <app-paginator
          [currentPage]="inspectionService.currentPage$ | async"
          [pageCount]="inspectionService.pageCount$ | async"
          [atFirstPage]="inspectionService.atFirstPage$ | async"
          [atLastPage]="inspectionService.atLastPage$ | async"
          [pageSize]="inspectionService.pageSize$ | async"
          [pageSizeOptions]="inspectionService.pageSizeOptions$ | async"
          (nextPage)="getNextPage($event)"
          (previousPage)="getPreviousPage($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (pageChange)="onPageChange($event)"
        ></app-paginator>
      </div>
    </div>
    <div class="table">
      <app-inspection-table [hidden]="state === InspectionPageState.LOADING"
        [data]="filteredGoods"
        (clicked)="onClicked($event)"
        (onFilterChange)="applyFilter($event)"
        (onTaskRequest)="openTaskRequest($event)"
        (onSelect)="getSelectedValue($event)">
      </app-inspection-table>

      <div class="loader" *ngIf="state === InspectionPageState.LOADING">
        <mat-spinner [diameter]="30"></mat-spinner>
      </div>
      <div class="empty" *ngIf="filteredGoods?.length === 0 && state !== InspectionPageState.LOADING">
        NÃO EXISTEM ITENS NESSA ETAPA NESSE MOMENTO.
      </div>
    </div>
  </div>
</app-side-color-card>

<app-full-page-loader *ngIf="isLoadingModal"></app-full-page-loader>
